export class UploadVM {
    fileName: string;
    userId: string
}